import React, { useState, useEffect, useRef } from "react";
import "./EvenementsManagement.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Evenement from "../EvenementCard/EvenementCard";
import EvenementManagementCard from "./EvenementManagementCard/EvenementManagementCard";
import { updateEvents } from "Redux/Actions/eventsActions";
import {
  filterByTransmitter,
  formatDateDatabase,
  formatDateFrenchLocale,
} from "Services/functions";
import { updatePagination } from "Redux/Actions/paginationActions";
import Management from "Components/Management/Management";
import { formatDate } from "Services/functions";
import Loader from "Components/Loader/loader";
// import { Link } from "react-router-dom";
import { useFetchGetPagination } from "Services/api";
import TempPagination from "Components/Pagination/TempPagination";
import { ME, eventMgmtButtons } from "Components/Management/ManagementButtons";
/**
 * Permet d'afficher la page de gestion des événements
 */
const EvenementsManagement = (props) => {
  // *****************************************************************
  // ****************** UseStates / UseRef *********************
  // *****************************************************************
  const EventMngRef = useRef(null);
  const [url, setUrl] = useState(null);
  const [states, setStates] = useState([]);
  const [lastEvent, setLastEvent] = useState(null);
  const evenementsContainerRef = useRef(null);
  const [btnList, setBtnList] = useState(
    eventMgmtButtons.map((x) => {
      return { ...x };
    })
  );
  //? On ne fait pas de requête si aucun état n'est sélectionné
  //? Des états par défaut sont appliqués dans un useEffect
  //! Permet d'éviter de faire deux requêtes au chargement de la page
  useFetchGetPagination(url, props.auth.token, props.handleUpdateEvents);

  // *****************************************************************
  // ****************** UseEffect *********************
  // *****************************************************************
  useEffect(() => {
    props.handleUpdateEvents({
      currentTransmitter: [ME],
    });
    return () => {
      props.handleUpdateEvents({
        dataFromPagination: null,
      });
    };
  }, []);

  useEffect(() => {
    //? remise à zéro si les états sont chargés
    //? et que l'url ne contient pas de state
    if (states && states?.length > 0 && !url?.href?.includes("state")) {
      if (EventMngRef.current !== null) {
        window.scroll({
          top: EventMngRef.current.offsetTop,
          behavior: "smooth",
        });
      }
      let newUrl = new URL(`${process.env.REACT_APP_BASE_URL_API}/events`);
      newUrl.searchParams.set(
        "university[]",
        props.auth.universityConnected.id
      );
      newUrl.searchParams.set(
        "endingAt[after]",
        formatDateDatabase(new Date())
      );
      newUrl.searchParams.set("order[startingAt]", "asc");
      newUrl.searchParams.set("itemsPerPage", 20);
      states.forEach((state) => {
        newUrl.searchParams.append("state[]", state?.id);
      });
      newUrl.searchParams.append("createdBy[]", props.auth.userConnected.id);

      setUrl(newUrl);
      return () => {
        props.handleUpdatePagination({ currentPage: 1 });
        props.handleUpdatePagination({ paginationBasicFirst: 0 });
        props.handleUpdatePagination({ paginationBasicRows: 12 });
      };
    }
  }, [states]);

  useEffect(() => {
    /// Récupérer les states, et les filtrer par ordre alphabétique
    if (props.events.etats && props.events.etats.length > 0) {
      setStates([]);
      let tempArray = [];
      props.events.etats.forEach((state) => tempArray.push(state));
      tempArray = tempArray.sort((a, b) => a.name?.localeCompare(b.name));
      setStates(tempArray);
    }
  }, [props.events.etats]);

  // Hook qui se déclenche quand la liste des offres change
  useEffect(() => {
    // Charge la dernière offre en fonction de l'emetteur choisi
    props.events.dataFromPagination?.data &&
      url?.href?.includes("page=1") &&
      setLastEvent(props.events.dataFromPagination?.data[0]);
  }, [props.events.dataFromPagination?.data]);

  return (
    <div className="gestion_evenements" ref={EventMngRef}>
      <div className="gestion_evenements__title">
        <h1 className="h1_trait_dessus">
          {props.auth.isAdmin ? "Gérer les événements" : "Gérer mes événements"}
        </h1>
        <Management
          states={states}
          btnEntreprise={btnList[2]}
          actualPage={"événement"}
          currentTransmitter={
            btnList.filter((btn) => btn.isActive === true)[0].transmitter
          }
          updateFunction={props.handleUpdateEvents}
          setUrl={setUrl}
        ></Management>
      </div>
      <div className="gestion_evenements__body">
        <div className="gestion_evenements__body__left">
          {props.auth.isAdmin &&
            btnList.map((btnStatus, index) => {
              return (
                <button
                  className={
                    btnStatus.isActive
                      ? "btn-bleu " + "item" + index
                      : "btn-blanc " + "item" + index
                  }
                  onClick={() => {
                    setUrl(
                      filterByTransmitter(
                        "events",
                        url,
                        btnList[index].transmitter,
                        props.auth.userConnected.id
                      )
                    );
                    props.handleUpdateEvents({
                      currentTransmitter: btnList[index].transmitter,
                      dataFromPagination: null,
                    });
                    var i = 0;
                    setBtnList(
                      btnList.map((btn) => {
                        btn.isActive = i == index;
                        i++;
                        return btn;
                      })
                    );
                  }}
                  key={index}
                >
                  {btnList[index].text}
                </button>
              );
            })}
          <h3>Dernier événement créé</h3>
          {/* Affichage du dernier evenement */}
          {lastEvent !== null && lastEvent !== undefined && (
            // <Link
            //   to={{
            //     pathname: `/event-detail/${lastEvent.id}?r=${
            //       typeof lastEvent.transmitter === "string" &&
            //       lastEvent.transmitter === "Recruteur"
            //     }`,
            //   }}
            // >
            <Evenement
              categorie={lastEvent.category}
              debutDate={formatDate(lastEvent.startingAt, ".")}
              finDate={formatDate(lastEvent.endingAt, ".")}
              inscription={lastEvent.fulfilled}
              title={lastEvent.title}
              chapeau={lastEvent.description}
              eventDetails={lastEvent}
              url={lastEvent?.imageUrl ? lastEvent.imageUrl : "event1"}
              registerEnd={lastEvent.registerEnd}
            />
            // </Link>
          )}
        </div>
        <div
          className="gestion_evenements__body__right"
          ref={evenementsContainerRef}
        >
          {/* Tant que la data n'est pas chargé on affiche un loader */}
          {props.events.dataFromPagination?.loaded > 0 ? (
            props.events.dataFromPagination?.data?.length > 0 ? (
              props.events.dataFromPagination.data[0]?.state &&
              props.events.dataFromPagination.data
                .filter(
                  (event) =>
                    event.state.statusLabel !== "Brouillon" ||
                    event.createdBy.id == props.auth.userConnected.id
                )
                .map((event, index) => (
                  <EvenementManagementCard
                    titre={event.title}
                    dateDebut={formatDateFrenchLocale(event.startingAt)}
                    dateFin={formatDateFrenchLocale(event.endingAt)}
                    participants={event.eventParticipants}
                    statut={event.state}
                    url={event?.imageUrl ? event.imageUrl : "event2"}
                    key={index}
                    id={event.id}
                    feedback={event.feedback?.feedback}
                    transmitterName={props.events.currentTransmitter[0]}
                  />
                ))
            ) : (
              <span>Aucun événement ne correspond à votre recherche</span>
            )
          ) : (
            <Loader />
          )}
        </div>
      </div>

      <TempPagination
        result={props.events.dataFromPagination}
        refItemParent={evenementsContainerRef}
        rows={20}
      />
    </div>
  );
};

EvenementsManagement.propTypes = {
  auth: PropTypes.object,
  nbActus: PropTypes.number,
  pageActus: PropTypes.string,
  filtre: PropTypes.string,
  filtres: PropTypes.array,
  setFiltre: PropTypes.func,
  events: PropTypes.any,
  handleUpdateEvents: PropTypes.func,
  pagination: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  events: state.events,
  pagination: state.pagination,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateEvents: (value) => {
    dispatch(updateEvents(value));
  },
  handleUpdatePagination: (value) => {
    dispatch(updatePagination(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvenementsManagement);
